module.exports = __webpack_public_path__ + "static/bottom_bar_4-d4569fc5558fb78695b0757379b05942.png";